import React, { useEffect, useState } from 'react';

import loadable from '@loadable/component';
import APIS from '../../constant/Endpoint';
import useGetHook from '../../customHooks/useGetHook';
import usePatchHook from '../../customHooks/usePatchHook';
import Spinner from '../../components/Reusable/Spinner';
import Skeleton from '../../components/Reusable/Skeleton';
const MerchantSettingComponent = loadable(
  () => import('../../components/MerchantSetting')
);

export const MerchantSetting = () => {
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [defaultValue, setDefaultValue] = useState<any>([]);
  const [URL, setURL] = useState<any>(`${APIS.GRID_REPORT_DATA_LOGISTIC}`);
  const { data: statusList } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.STATUS}`,
    params: {
      is_active: true,
    },
  });
  const { data: client_type, isLoading: isClientDataLoading } = useGetHook({
    queryKey: [`client-type`],
    url: `${APIS.CLIENT_TYPE}`,
    params: {},
  });
  useEffect(() => {
    {
      client_type?.type === 'logistic'
        ? setURL(`${APIS.GRID_REPORT_DATA_LOGISTIC}`)
        : setURL(`${APIS.GRID_REPORT_DATA_COURIER}`);
    }
  }, [client_type]);

  const { data: gridData, isLoading } = useGetHook({
    queryKey: [`grid-data-merchant-${URL}`],
    url: URL,
    params: {
      parent__slug: 'merchant',
    },
  });

  const { mutateAsync, isLoading: patchLoading } = usePatchHook({
    queryKey: ['grid-data-merchant'],
    navigateURL: '',
  });

  const handleOpenEditPopup = (item: any) => {
    setSelectedItem(item);
    setDefaultValue([...item?.status]);
    setOpenEditPopup(true);
  };

  const handleStatusInclude = async (event: any) => {
    event.preventDefault();

    const url = `${URL}${selectedItem?.id}/`;
    let formData = {
      status: defaultValue?.map((item: any) => item.id) ?? [],
    };
    try {
      const rest = await mutateAsync({ url, formData });
      if (rest.status === 200) {
        setOpenEditPopup(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {isLoading || isClientDataLoading ? (
        <Skeleton limit={5} />
      ) : (
        <MerchantSettingComponent
          gridData={gridData}
          statusList={statusList}
          patchLoading={patchLoading}
          handleStatusInclude={handleStatusInclude}
          setSelectedItem={setSelectedItem}
          setOpenEditPopup={setOpenEditPopup}
          openEditPopup={openEditPopup}
          //  handleEditStatusChange={handleEditStatusChange}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
          handleOpenEditPopup={handleOpenEditPopup}
        />
      )}
    </>
  );
};
